import axios from "axios";
import { Message } from "element-ui"; // 如果使用 Element UI 的提示组件
import store from "@/store"; // 如果要用到 Vuex
import router from "@/router"; // 如果需要路由跳转
// 引入配置文件
const defaultSettings = require("@/settings.js");
// 接口地址
const hostName = defaultSettings.hostName;

// 创建 axios 实例
const service = axios.create({
	baseURL: hostName, // 从环境变量获取基础 API 地址
	timeout: 1000 * 60, // 请求超时时间
});

// 记录正在进行的请求数量
let loadingRequestCount = 0;

// 显示 Loading
function showLoading(config) {
	// 如果配置中设置了不显示 loading，则跳过
	if (config.headers && config.headers.showLoading) {
		// 第一个请求时显示 loading
		if (loadingRequestCount === 0) {
			store.commit("SHOWLOADING");
		}
		loadingRequestCount++;
		return true;
	} else {
		return false;
	}
}

// 隐藏 Loading
function hideLoading(shouldCount) {
	// 只有参与 Loading 计数的请求才减少计数
	if (shouldCount) {
		loadingRequestCount--;
		// 所有需要 Loading 的请求都完成时隐藏 loading
		if (loadingRequestCount <= 0) {
			store.commit("HIDELOADING");
			loadingRequestCount = 0; // 重置计数器
		}
	}
}

// 请求拦截器
service.interceptors.request.use(
	(config) => {
		// 在发送请求之前做些什么
		// 在 config 上标记这个请求是否参与 Loading 计数
		config._shouldCountLoading = showLoading(config);

		// 如果存在 token，则带上 token
		const token = window.sessionStorage.getItem("token") || "";
		if (token) {
			config.headers["token"] = token;
		}

		// 可以在这里添加其他自定义 header
		// config.headers['X-Custom-Header'] = 'custom-value'

		return config;
	},
	(error) => {
		// 请求错误时也要处理可能的 Loading
		if (error.config && error.config._shouldCountLoading) {
			hideLoading(true);
		}
		// 对请求错误做些什么
		console.log(error); // for debug
		return Promise.reject(error);
	},
);

// 响应拦截器
service.interceptors.response.use(
	(response) => {
		// 对响应数据做点什么
		// 根据请求时的标记决定是否减少 Loading 计数
		hideLoading(response.config._shouldCountLoading);
		const res = response.data;

		if (response.data.code == 4) {
			window.sessionStorage.clear();
			store.commit("HIDELOADING");
			router.push("/login");
			Message.error(response.data.msg);
			window.axiosCancel = true;
			return;
		}

		return res; // 只返回实际需要的数据部分
	},
	(error) => {
		// 对响应错误做点什么
		console.log("err" + error); // for debug
		// 响应错误时也要处理可能的 Loading
		if (error.config && error.config._shouldCountLoading) {
			hideLoading(true);
		}
		// HTTP 状态码处理
		if (error.response) {
			switch (error.response.status) {
				case 400:
					error.message = "请求错误";
					break;
				case 401:
					error.message = "未授权，请登录";
					// 跳转到登录页
					// router.push("/login");
					break;
				case 403:
					error.message = "拒绝访问";
					break;
				case 404:
					error.message = `请求地址出错: ${error.response.config.url}`;
					break;
				case 408:
					error.message = "请求超时";
					break;
				case 500:
					error.message = "服务器内部错误";
					break;
				case 501:
					error.message = "服务未实现";
					break;
				case 502:
					error.message = "网关错误";
					break;
				case 503:
					error.message = "服务不可用";
					break;
				case 504:
					error.message = "网关超时";
					break;
				case 505:
					error.message = "HTTP版本不受支持";
					break;
				default:
					error.message = `连接错误 ${error.response.status}`;
			}
		} else if (error.message.includes("timeout")) {
			error.message = "请求超时";
		} else if (error.message === "Network Error") {
			error.message = "网络连接错误";
		}

		Message.error(error.message);
		return Promise.reject(error);
	},
);

export default service;
